import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PowerSupplyService, PowerSupplyAputypesService, NaturalGasProviderService } from '@psnb/services';
import { ApuType, Apu, NaturalGasProvider } from '@psnb/psnb-api';
import { NumberOnlyValidation } from '../numberOnly.validation';
import { CommonService } from '../../../common/common.service';

@Component({
  selector: 'nwt-power-supply-edit-apu',
  templateUrl: './power-supply-edit-apu.component.html',
  styleUrls: ['./power-supply-edit-apu.component.scss']
})
export class PowerSupplyEditApuComponent implements OnInit {

  apuFormGroup: FormGroup;
  apuMakeModels: ApuType[] = [];
  deviceIds: number[] = [1, 2, 3, 4, 5];
  ecmAcms: string[] = ['ECM', 'ACM'];
  apuOpVltgRatings: string[] = ['36V', '48V'];
  apuEnclosures: string[] = [];
  ngLps: string[] = ['NG', 'LP'];
  ngProvideres: NaturalGasProvider[] = [];
  id: number = 0;
  powerSupplyId: number = 0;
  supplyName: string = '';
  sysContact: string = '';
  sysLocation; string = '';
  showProgressBar = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder,
    private naturalGasProviderService: NaturalGasProviderService,
    private powerSupplyAputypesService: PowerSupplyAputypesService,
    private powerSupplyResourceService: PowerSupplyService,
    private commonService: CommonService,
    public dialogRef: MatDialogRef<PowerSupplyEditApuComponent>
  ) { }

  ngOnInit() {
    this.showProgressBar = true;
    this.powerSupplyId = this.data.id;
    this.apuEnclosures = this.data.cabinetVendors;
    this.supplyName =  this.data.supplyName;
    this.sysContact = this.data.sysContact;
    this.sysLocation = this.data.sysLocation;
    this.naturalGasProviderService.getAllNaturalGasProviderFromService().subscribe(res => {
      this.ngProvideres = res;
    });
    this.powerSupplyAputypesService.getAllApuTypesFromService().subscribe(res => {
      this.apuMakeModels = res;
    });
    this.apuFormGroup = this.fb.group({
      apuMakeModel: [''],
      apuSerialNumber: [''],
      apuDeviceId: [''],
      apuRunTime: [''],
      ecmAcm: [''],
      dateApuInstalled: [''],
      apuOpVltgRating: [''],
      apuNoLoadVltg: ['', [ NumberOnlyValidation.ValidateNumber()]],
      apuLoadVltg: ['', [ NumberOnlyValidation.ValidateNumber()]],
      apuEnclosure: [''],
      ngLp: [''],
      ngProvider: [''],
      lpTankCapacity: [''],
      noOfTanksInstalled: ['', [ NumberOnlyValidation.ValidateNumber()]],
    });

    if (this.powerSupplyId != null && this.powerSupplyId != 0) {
      this.powerSupplyResourceService.getApuByPowerSupplyId(this.powerSupplyId).subscribe( (res: any) => {
        if (res.id != 0 && res.id != null) {
          this.id = res.id;
          let date: Date = null;
          if (res.dateApuInstalled != null && res.dateApuInstalled != 0) date = new Date(res.dateApuInstalled);
          this.apuFormGroup.patchValue({
            apuMakeModel: res.apuMakeModel,
            apuSerialNumber: res.apuSerialNumber,
            apuDeviceId: res.apuDeviceId,
            apuRunTime: res.apuRunTime,
            ecmAcm: res.ecmAcm,
            dateApuInstalled: date,
            apuOpVltgRating: res.apuOutputVoltageRating,
            apuNoLoadVltg: res.apuNoLoadVoltage,
            apuLoadVltg: res.apuLoadVoltage,
            apuEnclosure: res.apuEnclosureMake,
            ngLp: res.ngLp,
            ngProvider: res.ngProvider,
            lpTankCapacity: res.lpTankCapacity,
            noOfTanksInstalled: res.numberOfTanks
          });
        } else this.id = 0;
        this.showProgressBar = false;
      }, err => {
        this.showProgressBar = false;
      });
    } else this.showProgressBar = false;
  }

  saveApuChanges() {
    this.showProgressBar = true;
    const jsonApu: Apu = {};
    jsonApu.apuMakeModel = this.apuFormGroup.value.apuMakeModel;
    jsonApu.apuSerialNumber = this.apuFormGroup.value.apuSerialNumber;
    jsonApu.apuDeviceId = this.apuFormGroup.value.apuDeviceId;
    jsonApu.apuRunTime = this.apuFormGroup.value.apuRunTime;
    jsonApu.ecmAcm = this.apuFormGroup.value.ecmAcm;
    if (this.apuFormGroup.value.dateApuInstalled != null) {
      let date = new Date(this.apuFormGroup.value.dateApuInstalled);
      jsonApu.dateApuInstalled = date.getTime();
    } else jsonApu.dateApuInstalled = null;
    jsonApu.apuOutputVoltageRating = this.apuFormGroup.value.apuOpVltgRating;
    jsonApu.apuNoLoadVoltage = this.apuFormGroup.value.apuNoLoadVltg;
    jsonApu.apuLoadVoltage = this.apuFormGroup.value.apuLoadVltg
    jsonApu.apuEnclosureMake = this.apuFormGroup.value.apuEnclosure;
    jsonApu.ngLp = this.apuFormGroup.value.ngLp;
    jsonApu.ngProvider = this.apuFormGroup.value.ngProvider;
    jsonApu.lpTankCapacity = this.apuFormGroup.value.lpTankCapacity;
    jsonApu.numberOfTanks = this.apuFormGroup.value.noOfTanksInstalled;
    jsonApu.powerSupplyId = this.powerSupplyId;

    if (this.id == 0) {
      this.powerSupplyResourceService.createApu(jsonApu).subscribe(res => {
        this.showProgressBar = false;
        if (res.success === true) {
          const activity = 'PowerSupply Edit - APU Save';
          const message = 'PowerSupply APU Create Success. Data: ' + JSON.stringify(jsonApu);
          this.commonService.loggerPost(message, activity, 3);
          this.dialogRef.close('CREATED');
        } else {
          const activity = 'PowerSupply Edit - APU Save - Error';
          const message = 'PowerSupply APU Create Error. Data: ' + JSON.stringify(jsonApu);
          this.commonService.loggerPost(message, activity, 5);
          this.dialogRef.close('FAILED');
        }
      },
        err => {
          const activity = 'PowerSupply Edit - APU Save - Error';
          const message = 'PowerSupply APU Create Error. Data: ' + JSON.stringify(jsonApu);
          this.commonService.loggerPost(message, activity, 5);
          this.dialogRef.close('FAILED');
          this.showProgressBar = false;
      });
    } else {
      jsonApu.id = this.id;
      this.powerSupplyResourceService.updateApu(jsonApu).subscribe(res => {
        this.showProgressBar = false;
        if (res.success === true) {
          const activity = 'PowerSupply Edit - APU Save';
          const message = 'PowerSupply APU Update Success. Data: ' + JSON.stringify(jsonApu);
          this.commonService.loggerPost(message, activity, 3);
          this.dialogRef.close('UPDATED');
        } else {
          const activity = 'PowerSupply Edit - APU Save - Error';
          const message = 'PowerSupply APU Update Error. Data: ' + JSON.stringify(jsonApu);
          this.commonService.loggerPost(message, activity, 5);
          this.dialogRef.close('FAILED');
        }
      },
        err => {
          const activity = 'PowerSupply Edit - APU Save - Error';
          const message = 'PowerSupply APU Update Error. Data: ' + JSON.stringify(jsonApu);
          this.commonService.loggerPost(message, activity, 5);
          this.dialogRef.close('FAILED');
          this.showProgressBar = false;
      });
    }
  }

  cancel() {
    this.dialogRef.close('OK');
  }
}